var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3081 7.5V5.5H8.80811V8.5V9H8.30811H5.30811V14.5H12.3081V13.5H13.3081V14.5V15.5H12.3081H5.30811H4.30811V14.5V7.5L7.30811 4.5H8.80811H12.3081H13.3081V5.5V7.5H12.3081ZM7.72232 5.5H7.80811V8H5.30811V7.91421L7.72232 5.5Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8301 8.75521L12.532 10.0533L11.2339 8.75521L11.1279 8.64915L11.0218 8.75521L10.6708 9.10625L10.5647 9.21232L10.6708 9.31839L11.9689 10.6165L10.7188 11.8666L10.6127 11.9727L10.7188 12.0787L11.0698 12.4298L11.1759 12.5358L11.2819 12.4298L12.532 11.1797L13.8301 12.4778L13.9362 12.5838L14.0423 12.4778L14.3933 12.1267L14.4994 12.0207L14.3933 11.9146L13.0952 10.6165L14.3933 9.31839L14.4994 9.21232L14.3933 9.10625L14.0423 8.75521L13.9362 8.64915L13.8301 8.75521Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileFalse);
export default __webpack_public_path__ + "static/media/ico-file-false.2c4c31a1f20fdafd4150670f806e985b.svg";
export { ForwardRef as ReactComponent };